export const PROFORM_INVOICE_LIST_REQUEST   = 'PROFORM_INVOICE_LIST_REQUEST';
export const PROFORM_INVOICE_LIST_SUCCESS   = 'PROFORM_INVOICE_LIST_SUCCESS';
export const PROFORM_INVOICE_LIST_FAIL      = 'PROFORM_INVOICE_LIST_FAIL';
export const PROFORM_INVOICE_LIST_UPDATE    = 'PROFORM_INVOICE_LIST_UPDATE';